<ng-container *transloco="let t">
  <app-child-form [submitButtonText]="t('child/addChild')" (formSubmit)="createChild($event)"></app-child-form>
</ng-container>
